export default __webpack_public_path__ + "../img/ca600c0329a9a68952c3cc090071296b.png";